import { render, staticRenderFns } from "./EnterAmend.vue?vue&type=template&id=6afb9acb&scoped=true&"
import script from "./EnterAmend.vue?vue&type=script&lang=js&"
export * from "./EnterAmend.vue?vue&type=script&lang=js&"
import style1 from "./EnterAmend.vue?vue&type=style&index=1&id=6afb9acb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afb9acb",
  null
  
)

export default component.exports